// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__UVb01","label":"styles_label__j4BR_","icon":"styles_icon__pxDNE"};